// removed by extract-text-webpack-plugin
module.exports = {"heading":"ResetPassword-hashed__heading__3I3MC","actionsWrapper":"ResetPassword-hashed__actionsWrapper__2C5p0","button":"ResetPassword-hashed__button__3qIFK","inputGroup":"ResetPassword-hashed__inputGroup__MVbOC","input":"ResetPassword-hashed__input__2tLRM","error":"ResetPassword-hashed__error__2_Pq-","hasError":"ResetPassword-hashed__hasError__3uHL6"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/ResetPassword/ResetPassword-hashed.scss
// module id = 1156
// module chunks = 0